export default function BookmarkIcon({ className }: { className?: string }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M7.49984 8.75L9.1665 10.4167L12.9165 6.66667M15.8332 17.5V6.5C15.8332 5.09987 15.8332 4.3998 15.5607 3.86502C15.321 3.39462 14.9385 3.01217 14.4681 2.77248C13.9334 2.5 13.2333 2.5 11.8332 2.5H8.1665C6.76637 2.5 6.06631 2.5 5.53153 2.77248C5.06112 3.01217 4.67867 3.39462 4.43899 3.86502C4.1665 4.3998 4.1665 5.09987 4.1665 6.5V17.5L9.99984 14.1667L15.8332 17.5Z" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  );
}

export const displayName = "BookmarkIcon";
